import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { managedData, deleteData } from "../api/data";
import Swal from 'sweetalert2';
import EditSvg from '../assets/svg/edit.svg';
import DeleteSvg from '../assets/svg/delete.svg';

const ManagedData = ({ close }) => {
  const [filter, setFilter] = useState("daily");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchData(page);
    const interval = setInterval(() => fetchData(page), 300000);
    return () => clearInterval(interval);
  }, [filter, startDate, endDate, page]);

  const user = localStorage.getItem('user');
  if (!user) {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'User not authenticated',
    });
    return;
  }

  const { username, api_key } = JSON.parse(user);

  const fetchData = async (currentPage) => {
    try {
      setLoading(true);
      const response = await managedData(filter, startDate, endDate, currentPage, limit, api_key);

      if (response.status === "success") {
        setData(response.data || []);
        const totalItems = response.pagination?.total_records || 0;
        setTotalPages(Math.max(1, Math.ceil(totalItems / limit)));
      } else {
        console.error("Error fetching data:", response.message);
      }
    } catch (error) {
      console.error("Unexpected error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      const response = await deleteData(id);
      if (response.status === "success") {
        Swal.fire("Deleted!", response.message, "success");
        setData((prevData) => prevData.filter(item => item.id !== id));
      } else {
        Swal.fire("Error!", response.message, "error");
      }
    }
  };

  return (
    <div className="popup-overlay">
      <motion.div
        className="popup-layer"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      >
        <div className="title">
          View Managed Data
          <button onClick={close}>Close</button>
        </div>

        <div className="filter-header">
          <select value={filter} onChange={(e) => setFilter(e.target.value)}>
            <option value="daily">This Day</option>
            <option value="weekly">This Week</option>
            <option value="monthly">This Month</option>
            <option value="yearly">This Year</option>
          </select>
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </div>

        <div className="table-container">
          {loading ? (
            <>
              <p className='load-text'>Loading table data...</p>
              <div className="loader">
                <div className="waves"></div>
              </div>
            </>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Main Tank Temperature</th>
                  <th>Reservoir Temperature</th>
                  <th>Pitcher Temperature</th>
                  <th>Heating</th>
                  <th>Cooling</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={index}>
                      <td>{item.peltierTemp || "-"}</td>
                      <td>{item.reservoirTemp || "-"}</td>
                      <td>{item.pitcherTemp || "-"}</td>
                      <td>{item.heating === 1 ? "On" : "Off"}</td>
                      <td>{item.cooling === 1 ? "On" : "Off"}</td>
                      <td>{item.created_at?.split(" ")[0] || "-"}</td>
                      <td>{item.created_at?.split(" ")[1] || "-"}</td>
                      <td className="action-grid">
                        {/* <button className="action edit"><img src={EditSvg} /></button> */}
                        <button className="action delete" onClick={() => handleDelete(item.id)}>
                          <img src={DeleteSvg} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8">No data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        <div className="pagination">
          <button
            onClick={() => setPage((prev) => prev - 1)}
            disabled={page === 1}
          >
            Previous
          </button>

          <button
            onClick={() => setPage((prev) => prev + 1)}
            disabled={page < totalPages}
          >
            Next
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default ManagedData;
